import React from "react";
import styled from "styled-components";
import LifeAtButton from "@common/LifeAtButton/LifeAtButton";
import { FontSize } from "@themes/Fonts";

const Button = styled(LifeAtButton)<{ colorOverride: string }>`
    justify-content: flex-start;
    padding-left: 0;
    border: none !important;

    .lifeat-button-text {
        color: ${({ colorOverride, theme }) => colorOverride ?? theme.textColorSecondary};
    }

    button {
        font-size: ${FontSize.normal};
        padding: 0;
    }
`;
interface DiscreteTextButtonProps {
    readonly label: string;
    readonly onClick: () => void;
    readonly colorOverride?: string;
    className?: string;
}
export default function DiscreteTextButton(props: DiscreteTextButtonProps) {
    return (
        <Button
            isLink={false}
            text={props.label}
            handleClick={props.onClick}
            className={props.className}
            colorOverride={props.colorOverride}
        />
    );
}
